import React from 'react'
import { Link } from 'react-router-dom';
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants';

const InfluencerActionCard = ({collabPage = false}) => {
    return (
        <React.Fragment>
                <div className="card card-style">
                    <div className="card-body">
                        <h3 className="pop">
                            Log in to Instagram to start collaborating
                        </h3>
                        <p>To {collabPage ? 'start' : 'apply for'} brand collaborations, please log in with your Instagram account first.</p>
                        <Link to={INIT_IG_AUTH_ROUTE} className="btn btn-sm btn-primary rounded-sm">Login with Instagram</Link>
                    </div>
                </div>
        </React.Fragment>
    )
}

export default InfluencerActionCard